import { AppSettings } from "../app/managers/AppSettings";
import { ScreenManager, ScreenManagerEvents } from "../managers/ScreenManager";
import { GetWindowSize } from "../utils/GetWindowSize";
import { RectSize } from "../utils/RectSize";


// 'catch all' errors using logger
// https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror
// EDIT: disabling for now, coz its eating all my errors (not passing them to console)
// window.onerror = function(message: string|Event, url:string, lineNumber:number)
// {  
//     logger.log(message.toString(), url, lineNumber.toString());
//     console.log("!!!",message)
//     return true;
// };

/**
 * Custom logger for phaser
 * Layouting: expects Scale.ENVELOPE for internal alignment calculations.
 */
export class logger 
{
    public static SCENE_KEY: string = "logger";
    public static scene: Phaser.Scene;
    public static logContainer: Phaser.GameObjects.Container;
    public static logField: Phaser.GameObjects.Text;

    private static gameWidth: number;
    private static gameHeight: number;
    // for simplicity, 0,0 is top left and 1,1 is bottom right of screen
    private static align: Phaser.Geom.Point = new Phaser.Geom.Point(0, 0);
    

    public static BringToTop(): void
    {
        // bring this scene to top of all others
        this.scene.scene.manager.bringToTop(this.scene);
    }

    /**
     * 
     * @param scene throw-away scene; only used to create/attach logger scene
     */
    public static Init(scene: Phaser.Scene): void
    {
        this.gameWidth = scene.sys.game.config.width as number
        this.gameHeight = scene.sys.game.config.height as number;

        // logger scene
        this.scene = scene.scene.add(this.SCENE_KEY, LoggerScene, true); // autostart?
    }

    public static Build(): void
    {
        // console.log("Build");

        // 
        this.logContainer = this.scene.add.container(
            0, 0
            // this.gameWidth, this.gameHeight
        );
        this.logField = this.scene.add.text(
            0, 0, "", {
                font: '50px Arial', 
                color: '#ff0000',
                backgroundColor: '#000',
                metrics: AppSettings.metrics.arial50,
            }
        );
        this.logField.scale = window.devicePixelRatio;
        this.logField.setOrigin(this.align.x, this.align.y);
        this.logContainer.add(this.logField);

        this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.OnUpdate, this);

        // refresh layout and listen RESIZE
        ScreenManager.GetEventEmitter().on(ScreenManagerEvents.RESIZE, this.OnResize, this);
        const windowRect = GetWindowSize();
        this.OnResize(windowRect);
    }

    public static log(...args: any[]): void
    {
        // console.log("log>>>", args);

        this.logField.text = args.toString();
    }

    public static logAdd(...args: string[]): void
    {
        // console.log("log>>>",args)
        args.forEach(arg=>this.logField.text = this.logField.text.concat(...args));
    }

    private static OnResize(windowRect: RectSize): void
    {
        // const screenOrientationType: ScreenOrientationType = ScreenManager.GetOrientation();
        const screenCenterX:number = (0.5 * windowRect.width)|0;
        const screenCenterY:number = (0.5 * windowRect.height)|0;

        this.logField.setPosition(0,0);
    }

    // private static OnUpdate(sys: Phaser.Scenes.Systems, time: number, delta: number): void
    private static OnUpdate(sys: Phaser.Scenes.Systems, time: number, delta: number): void
    {
        // bring logger scene to top of this scene
        // this.BringToTop();
        // this.log(Math.random().toString())
        this.log((this.scene.game.loop.actualFps|0).toString());
        // this.log(window.outerWidth, window.outerHeight, AppScaleManager.importedTextureScale);
    }
}

export class LoggerScene extends Phaser.Scene {}